(function (angular) {
    'use strict';

    angular.module('inboundRules')

        .config(['$stateProvider', function ($stateProvider) {


            function handleError($q, error) {
                var deferred = $q.defer();
                if (error.status < 500) { deferred.resolve(error); } else { deferred.reject(error); }
                return deferred.promise;
            }


            $stateProvider

                .state('main.apiSpace.inboundRules', {
                    url: '/inboundrules',
                    template: '<ui-view/>'
                })
                .state({
                    name: 'main.apiSpace.inboundRules.settings',
                    url: '/settings',
                    authenticate: true,
                    templateUrl: 'components/automation/inboundRules/settings/templates/inboundRulesSettings.html',
                    controller: 'inboundRulesSettingsCtrl',
                    resolve: {
                        inboundRules: ['$q', 'inboundRulesService', '$stateParams', function ($q, inboundRulesService, $stateParams) {

                            return inboundRulesService.getInboundRules($stateParams.pickedApiSpaceId)
                                .then(function (result) {
                                    return result;
                                }).catch(function (error) {
                                    return handleError($q, error);
                                });
                        }],
                        inboundData: ['$q', 'inboundRulesData', function ($q, inboundRulesData) {
                            return inboundRulesData.generateData()
                                .then(function (res) {
                                    return res;
                                }).catch(function (error) {
                                    return handleError($q, error);
                                });
                        }]
                    }
                });
        }]);

})(window.angular);
